import { inject, Injectable } from '@angular/core';
import {
  KFM_THEMING_DARK,
  KFM_THEMING_KEY,
  KFM_THEMING_LIGHT,
} from '@shared/constants/constants';
import { LocalStorageService } from '@shared/storage/local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class ThemingService {
  private readonly _localStorage = inject(LocalStorageService);

  constructor() {
    const prefersDark = window.matchMedia(
      '(prefers-color-scheme: dark)',
    ).matches;

    // Set localstorage if not set
    this._localStorage.get(KFM_THEMING_KEY).then(async (theme) => {
      if (!theme) {
        if (prefersDark) {
          await this.setTheme(KFM_THEMING_DARK);
        } else {
          await this.setTheme(KFM_THEMING_LIGHT);
        }
      } else {
        const isDarkMode = await this.isDarkMode();

        if (isDarkMode) {
          await this.setTheme(KFM_THEMING_DARK);
        } else {
          await this.setTheme(KFM_THEMING_LIGHT);
        }
      }
    });
  }

  public async toggleTheme(): Promise<void> {
    const isDarkMode = await this.isDarkMode();

    if (isDarkMode) {
      await this.setTheme(KFM_THEMING_LIGHT);
    } else {
      await this.setTheme(KFM_THEMING_DARK);
    }
  }

  public async isDarkMode(): Promise<boolean> {
    const theme = await this._localStorage.get(KFM_THEMING_KEY);
    return theme === KFM_THEMING_DARK;
  }

  private async setTheme(theme: string): Promise<void> {
    await this._localStorage.set(KFM_THEMING_KEY, theme);
    document.documentElement.classList.toggle(
      'dark',
      theme === KFM_THEMING_DARK,
    );
  }
}
